const u = (id) => `https://images.unsplash.com/photo-${id}?auto=format&fit=crop&w=1400&q=80`;
export const AUTH_BG = u("1532979772520-f2763956cce0");
export const LAKE_HERO = u("1788398483547-fa1cf9776a0f");
export const SHORE = u("1629909914920-a19cf7b595b5");
export const THUMBS = [u("1631941150945-837cb81fc7e2"), u("1698933787134-af2d451985c7"), u("1696814543664-3f5acf78349e"), u("1573849420475-4f1c7bf06fa7")];
export const thumbFor = (id = "") => THUMBS[(id.charCodeAt(id.length - 1) || 0) % THUMBS.length];

export function season(d = new Date()) {
  const m = d.getMonth();
  if (m === 11 || m <= 2) return "Snow on the lakes";
  if (m <= 4) return "Ice-out season";
  if (m <= 7) return "Dock season";
  return "Fall colours on the lakes";
}

export const MUSKOKA_ROOMS = ["Great Room", "Screened Porch", "Kitchen", "Primary Suite", "Bunkie", "Boathouse", "Mudroom", "Guest Loft"];
